export default {
  name: 'transaction_informations_sms',
  component_path: 'modules/procedures/blocks/BlockInputCheckbox'
}